// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3kJOQ","modalFooterButton":"ModalNotes_modalFooterButton__346ZC"};